@if (total > 0) {
  <div class="hc-pagination">
    <!-- Summary -->
    @if (showSummary) {
      <div class="hc-pagination__summary">
        {{ 'pagination.showing' | translate }} <strong>{{ startItem }}</strong> - <strong>{{ endItem }}</strong> {{ 'pagination.of' | translate }} <strong>{{ total }}</strong>
      </div>
    }
    <!-- Page Size Selector -->
    @if (showPageSizeSelector) {
      <div class="hc-pagination__size">
        <label class="hc-pagination__size-label">{{ 'pagination.show' | translate }}</label>
        <ng-select
          class="hc-pagination__size-select"
          [items]="pageSizeOptions"
          [ngModel]="perPage"
          [searchable]="false"
          [clearable]="false"
          (change)="onPageSizeChange($event)">
        </ng-select>
        <span class="hc-pagination__size-label">{{ 'pagination.entries' | translate }}</span>
      </div>
    }
    <!-- Navigation -->
    <nav class="hc-pagination__nav" aria-label="Pagination">
      <!-- First Page -->
      @if (showFirstLastButtons) {
        <button
          type="button"
          class="hc-pagination__btn hc-pagination__btn--first"
          [disabled]="isFirstPage"
          (click)="firstPage()"
          aria-label="First page"
          >
          <lucide-icon name="chevrons-left"></lucide-icon>
        </button>
      }
      <!-- Previous Page -->
      <button
        type="button"
        class="hc-pagination__btn hc-pagination__btn--prev"
        [disabled]="isFirstPage"
        (click)="previousPage()"
        aria-label="Previous page"
        >
        <lucide-icon name="chevron-left"></lucide-icon>
      </button>
      <!-- Page Numbers -->
      @for (pageNum of pageNumbers; track trackByPage($index, pageNum)) {
        @if (pageNum === '...') {
          <span class="hc-pagination__ellipsis">...</span>
        }
        @if (pageNum !== '...') {
          <button
            type="button"
            class="hc-pagination__btn hc-pagination__btn--page"
            [class.hc-pagination__btn--active]="pageNum === page"
            [attr.aria-current]="pageNum === page ? 'page' : null"
            (click)="goToPage(pageNum)"
            >
            {{ pageNum }}
          </button>
        }
      }
      <!-- Next Page -->
      <button
        type="button"
        class="hc-pagination__btn hc-pagination__btn--next"
        [disabled]="isLastPage"
        (click)="nextPage()"
        aria-label="Next page"
        >
        <lucide-icon name="chevron-right"></lucide-icon>
      </button>
      <!-- Last Page -->
      @if (showFirstLastButtons) {
        <button
          type="button"
          class="hc-pagination__btn hc-pagination__btn--last"
          [disabled]="isLastPage"
          (click)="lastPage()"
          aria-label="Last page"
          >
          <lucide-icon name="chevrons-right"></lucide-icon>
        </button>
      }
    </nav>
  </div>
}
